import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const SortAsc = createSvgIcon(
  <path d="m12 6 9 12H3l9-12Z" />,
  'SortAsc'
);

export { SortAsc };
